import { render, staticRenderFns } from "./choix-de-la-date.vue?vue&type=template&id=08a8585f"
import script from "./choix-de-la-date.vue?vue&type=script&lang=ts"
export * from "./choix-de-la-date.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports